import type { ReactNode } from 'react';
import { cn } from './cn';

export interface SpecItem {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
}

/**
 * Spec Band — the site's signature component (DESIGN §5), reused as the console's metadata
 * strip and dashboard stat tiles. Canvas Deep Sand, mono values (tnum), mono mute labels.
 */
export function SpecBand({ items, className }: { items: SpecItem[]; className?: string }) {
  return (
    <div
      className={cn(
        'grid grid-cols-2 gap-px overflow-hidden rounded-md bg-hairline lg:grid-cols-4',
        className,
      )}
    >
      {items.map((it) => (
        <div key={it.label} className="bg-canvas-deep-sand px-lg py-md">
          <div className="tnum font-mono text-mono-spec text-ink-deep">{it.value}</div>
          <div className="mt-2xs font-mono text-label-sm uppercase tracking-[0.12em] text-ink-mute">
            {it.label}
          </div>
          {it.hint && <div className="mt-2xs text-small text-ink-mid">{it.hint}</div>}
        </div>
      ))}
    </div>
  );
}
